import { Component, OnInit, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Validators, FormBuilder, FormControl } from "@angular/forms";
import { AuthService } from "src/providers/auth.service";
import { HttpService } from "src/providers/http.service";
import { ENV } from "src/environments/environment-variables.token";
import { UtilsProvider } from "src/commons/utils";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss", "../app.component.scss"],
})
export class LoginComponent implements OnInit {
    public loginForm: any;
    public loginFormStep: any;

    constructor(
        public router: Router,
        public formBuilder: FormBuilder,
        public auth: AuthService,
        public http: HttpService,
        public utils: UtilsProvider,
        @Inject(ENV) public ENV: any
    ) { }

    ngOnInit() {
        const email = new FormControl("", Validators.compose([Validators.required, Validators.email]));
        const password = new FormControl("", Validators.compose([Validators.required]));
        this.loginFormStep = 0;
        this.http.getToken().then(token => {
            if (token) {

                this.auth.me().then(() => {
                    this.router.navigate(["/pages"]);
                });
            }
        }).catch(err => {
            return this.utils.toast({
				message: "Ocorreu um erro ao realizar login, tente novamente mais tarde",
				duration: 10000,
				action: "Ok"
			});
        });

        this.loginForm = [
            {
                fields: [
                    {
                        name: "email",
                        type: "email",
                        placeholder: "E-mail",
                        blurCallback() { }
                    },
                    {
                        name: "password",
                        type: "password",
                        placeholder: "Senha",
                        blurCallback() { }
                    },
                ],
                builder: this.formBuilder.group({
                    email: [
                        "",
                        Validators.compose([
                            Validators.required,
                            Validators.email
                        ]),
                    ],
                    password: [
                        "",
                        Validators.compose([
                            Validators.required,
                        ]),
                    ]
                }),
                validation_messages: {
                    email: [
                        { type: "required", message: "Preencha o seu e-mail." },
                    ],
                    password: [
                        { type: "required", message: "Preencha sua senha." },
                    ],
                },
            },
        ];
    }

    clean() {
        this.loginForm[0].builder.reset();
    }

    onSubmit(event) {
        const data = { ...event[0].builder.value };
        console.log("data: ", data);
        this.auth.login(data).then(res => {
            this.clean();
            if (res !== "") {
                // this.auth.me();
                this.router.navigate(["/pages"]);
            } else {
                console.log(res); }
        }).catch(err => console.log(err)
        );
    }
}
